import gql from 'graphql-tag'

export default gql`
  query GetOrder($orderId: ID!, $cartId: UUID!) {
    order(orderId: $orderId, cartId: $cartId) {
      id
      email
      status
      paymentMethod
      paymentStatus
      orderAmount
      items {
        id
        sku
        productId
        salesPrice
        category
        name
        productId
        image {
          url
          description
        }
        ... on GenericCartItem {
          description
          quantity
        }
        ... on GiftCardCartItem {
          value
          recipientDetails {
            recipientName
            message
            ... on VirtualRecipientDetails {
              recipientEmail
              senderName
              deliveryDate
              deliveryMethod
            }
          }
        }
      }
    }
  }
`
